import moment from 'moment';
import { formatCurrency } from '../../utility/number.utils';
import type { ColumnConfig } from '../ui/Table';
import { Button } from 'react-bootstrap';
import { EyeIcon } from '../../assets/Icon';

export const columns: ColumnConfig[] = [
  {
    title: 'Txn Date',
    key: 'createdAt',
    sortable: false,
    renderer: (value: Date) =>
      value ? moment(value).format('MMM D YYYY, HH:mm:ss') : null,
  },
  {
    title: 'Txn Type',
    key: 'transactionType',
    sortable: false,
    width: '300px',
  },
  {
    title: 'Transfered Tkn',
    key: 'transferredToken',
    sortable: false,
    renderer: (value: string | number) =>
      formatCurrency(value, { currency: '', decimals: 0 }),
  },
  {
    title: 'Employee/Client Name',
    key: 'name',
    sortable: false,
  },
  {
    title: 'Department',
    key: 'department',
    sortable: false,
  },
  {
    title: 'Fiat',
    key: 'fiat',
    sortable: false,
  },
  {
    title: 'Status',
    key: 'status',
    sortable: false,
    renderer: (value: string) => (
      <span
        className={`fw-semibold text-${value === 'Settled' ? 'success' : 'danger'}`}
      >
        {value}
      </span>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    renderer: () => (
      <div className="d-flex">
        <Button variant="plain">
          <EyeIcon color="#666666" />
        </Button>
      </div>
    ),
  },
];
